import { createSlice } from '@reduxjs/toolkit'

export const contactFormSlice = createSlice({
	name: 'contactForm',
	initialState: {
		wasContactMessageDelivered: false,
	},
	reducers: {
		getContactFormMessageSuccess: (state, { payload }) => {
			state.wasContactMessageDelivered = true
		},
		clearContactFromMessageSuccess: (state, { payload }) => {
			state.wasContactMessageDelivered = false
		},
	},
})

export const {
	getContactFormMessageSuccess,
	getStepsProviderError,
	clearContactFromMessageSuccess,
} = contactFormSlice.actions

export const { reducer } = contactFormSlice
